export interface FormCheckBoxText {
  className?: string
  children?: React.ReactNode
  htmlFor?: string
}

export function FormCheckBoxText({
  className = '',
  children,
  htmlFor = '',
}: FormCheckBoxText) {
  return (
    <label htmlFor={htmlFor} className={`${className}`}>
      {children}
    </label>
  )
}

export default FormCheckBoxText
